module.exports = __webpack_public_path__ + "img/addRound.1f5d6204.svg";